import * as React from 'react'
import WheelButton from './cta/WheelButton'
import WheelAnalyticsManager from '../analytics/WheelAnalyticsManager'
import TSConstants from '../utils/TSConstants'
import {
  goToRedeem,
  nextLotteryStep,
  setLotteryLoading,
} from '../redux/actions/lottery'
import { useDispatch } from 'react-redux'
import LotteryV2Step from '@tootsweet/model/lottery/LotteryV2Step'
import { tt } from '../i18n'
import { share } from '../app/helpers/share'
import { FunctionComponent } from 'react'

interface Props {
  isFixedBottom?: boolean
  step: LotteryV2Step | null
  isIOS: boolean
  preventNextStep: boolean
  isAfterWheel?: boolean
}

const StaffingButton: FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch()

  const { step, isFixedBottom } = props

  if (!step) {
    return null
  }

  const onClick = () => {
    WheelAnalyticsManager.logEvent('staffing_link_click')

    share(props.step?.tag || undefined)

    if (props.isAfterWheel) {
      setTimeout(() => {
        dispatch(goToRedeem())
      }, 1000)
      return
    }

    dispatch(setLotteryLoading(true, props.step || undefined))

    setTimeout(() => {
      if (!props.preventNextStep) {
        dispatch(nextLotteryStep())
      }
      dispatch(setLotteryLoading(false))
    }, TSConstants.LOADER_TIMEOUT_SHORT)
  }

  return (
    <WheelButton
      text={tt('were_hiring_cta')}
      onClick={onClick}
      isFixedBottom={isFixedBottom}
    />
  )
}

export default StaffingButton
